module.exports = __webpack_public_path__ + "img/effect-1.b318c1fd.jpg";